import Link from 'next/link'
import { FunctionComponent } from 'react'
import routes from '@/hooks/use-authorization/routes'
import { useI18n } from '@/hooks/use-i18n'
import { useIntl } from '@/i18n/hooks/use-intl'

const BackToLoginLink: FunctionComponent = () => {
  const { formatMessage } = useIntl()
  const { rootLang } = useI18n()

  return (
    <Link href={routes.login.stringifyUrl({}, { lang: rootLang })}>
      {formatMessage({ id: 'account:register_back_login' })}
    </Link>
  )
}

export default BackToLoginLink
